export default {
  namespaced: true,

  state: () => ({
    open: 'flyer', // or null
    filterSortWindowOpen: false
  }),

  getters: {
    isFlyerOpen: s => s.open === 'flyer',
    isFilterOpen: s => s.open === 'filter',
    isFilterSortWindowOpen: s => s.filterSortWindowOpen
  },

  mutations: {
    SET_OPEN(state, which) {
      state.open = which; // 'flyer' | 'filter' | null
    },
    SET_FILTER_SORT_WINDOW_OPEN(state, value) {
    state.filterSortWindowOpen = value;
  }
  },

  actions: {
    openFlyer({ commit }) {
      commit('SET_OPEN', 'flyer');
    },

    openFilter({ commit }) {
      commit('SET_OPEN', 'filter');
    },

    closeAll({ commit }) {
      commit('SET_OPEN', null);
    },

   setFilterSortWindowOpen({ commit }, value) {
    commit('SET_FILTER_SORT_WINDOW_OPEN', value);
  }
  }
};
